import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { createSectionFourTwoRecord } from "../utils/create-section-four-two-record";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemPartOneId: string;
  itemPartTwo: {
    defectFixingFactDate: string;
    otherDocuments: {
      fileMetadata: {
        fileNumber: number;
        fileName: string;
        fileType: string;
        fileContentLength: number;
      };
    }[];
    defectFixingInspectionEmployeeId: string;
  };
}

export const useCreateSectionTwoFourEntry = ({
  itemNoVersionId,
  section4ListId,
}: {
  itemNoVersionId: string;
  section4ListId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) => {
      return createSectionFourTwoRecord({
        itemNoVersionId,
        sectionFourRequest: data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_CREATED_DESC, // "Запись создана"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ENTRY_CREATE_ERROR, // "Ошибка при создании записи"
        description: NOTIFICATION_MESSAGES.ENTRY_CREATE_FAILED_DESC, // "Не удалось создать запись"
      });
    },
  });
};
